import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=2f3387d3&scoped=true&"
import script from "./FormComponent.vue?vue&type=script&lang=js&"
export * from "./FormComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=2f3387d3&prod&lang=scss&"
import style1 from "./FormComponent.vue?vue&type=style&index=1&id=2f3387d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3387d3",
  null
  
)

export default component.exports